function initDonationModule() {
  const donationModule = document.querySelector('[data-donation-module]');
  if (!donationModule) return;

  if (donationModule.dataset.initialized === 'true') return;
  donationModule.dataset.initialized = 'true';

  window.donationModuleHidden = window.donationModuleHidden || false;
  if (window.donationModuleHidden) {
    donationModule.classList.add('hidden');
    return;
  }

  const dropdown = donationModule.querySelector('.donation-dropdown');
  const dropdownSelected = dropdown ? dropdown.querySelector('.dropdown-selected') : null;
  const dropdownOptions = dropdown ? dropdown.querySelector('.dropdown-options') : null;
  const addButton = donationModule.querySelector('.donation-add-btn');
  const loadingElement = donationModule.querySelector('.donation-loading');

  const closeButton = donationModule.querySelector('.donation-close-btn');
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      donationModule.classList.add('hidden');
      window.donationModuleHidden = true;
    });
  }

  if (!dropdown || !dropdownSelected || !dropdownOptions) return;

  let selectedVariantId = null;
  let selectedVariantTitle = null;
  let selectedPrice = 0;

  dropdownSelected.addEventListener('click', () => {
    const isActive = dropdownSelected.classList.contains('active');
    isActive ? closeDropdown() : openDropdown();
  });

  dropdownOptions.addEventListener('click', e => {
    const option = e.target.closest('.dropdown-option');
    if (!option) return;

    dropdownOptions.querySelectorAll('.dropdown-option').forEach(opt => opt.classList.remove('selected'));
    option.classList.add('selected');

    selectedVariantId = option.getAttribute('data-variant-id');
    selectedVariantTitle = option.getAttribute('data-variant-title');
    selectedPrice = parseInt(option.getAttribute('data-variant-price'));

    updateSelectedDisplay();
    enableAddButton();
    closeDropdown();
  });

  document.addEventListener('click', e => { if (!dropdown.contains(e.target)) closeDropdown(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDropdown(); });

  if (addButton) {
    addButton.addEventListener('click', () => {
      
      if (!selectedVariantId) return;
      loadingElement.style.display = 'flex';
      addToCart(selectedVariantId);
    });
  }

  function openDropdown() {
    dropdownSelected.classList.add('active');
    dropdownOptions.classList.add('active');
    const firstOption = dropdownOptions.querySelector('.dropdown-option');
    if (firstOption) firstOption.focus();
  }

  function closeDropdown() {
    dropdownSelected.classList.remove('active');
    dropdownOptions.classList.remove('active');
  }

  function updateSelectedDisplay() {
    if (selectedVariantTitle) {
      dropdownSelected.innerHTML = `
        <div class="selected-option">
          <div class="selected-amount">${selectedVariantTitle}</div>
        </div>
        <svg class="dropdown-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;
    }
  }

  function enableAddButton() {
    if (addButton) {
      addButton.disabled = false;
      addButton.classList.remove('disabled');
    }
  }

  function disableAddButton() {
    if (addButton) {
      addButton.disabled = true;
      addButton.classList.add('disabled');
    }
  }

  async function addToCart(variantId) {
    try {
      loadingElement.style.display = 'flex';

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );

      const body = JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          '_donation': 'true',
          '_donation_amount': selectedPrice,
          '_donation_description': selectedVariantTitle || 'Donation'
        },
        sections: sectionsToBundle
      });

      const addResponse = await fetch(`${FoxTheme.routes.cart_add_url}`, {
        ...FoxTheme.utils.fetchConfig(),
        body
      });

      const addResult = await addResponse.json();

      const cartResponse = await fetch('/cart.js');
      const fullCart = await cartResponse.json();

      const combinedCartData = {
        ...fullCart,
        sections: addResult.sections || {}
      };

      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        sources: 'cart-donation',
        cart: combinedCartData
      });

      loadingElement.style.display = 'none';
      donationModule.classList.add('donation-success');
      setTimeout(() => donationModule.classList.remove('donation-success'), 600);
      showNotification(`Donation of RS ${selectedPrice} added to cart!`, 'success');

      document.dispatchEvent(new CustomEvent('donation:added', {
        detail: {
          variantId: selectedVariantId,
          amount: selectedPrice,
          title: selectedVariantTitle
        }
      }));

      resetSelection();

    } catch (error) {
      console.error('Error adding donation to cart:', error);
      loadingElement.style.display = 'none';
      donationModule.classList.add('has-error');
      setTimeout(() => donationModule.classList.remove('has-error'), 3000);
      showNotification('Error adding donation. Please try again.', 'error');
    }
  }

  function resetSelection() {
    dropdownOptions.querySelectorAll('.dropdown-option').forEach(opt => opt.classList.remove('selected'));
    selectedVariantId = null;
    selectedVariantTitle = null;
    selectedPrice = 0;
    const placeholderText = donationModule.querySelector('.donation-dropdown').dataset.placeholder || 'Choose donation amount...';
    dropdownSelected.innerHTML = `
      <div class="dropdown-placeholder">${placeholderText}</div>
      <svg class="dropdown-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    disableAddButton();
  }

  function showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `donation-message ${type}`;
    notification.style.display = 'block';
    notification.textContent = message;
    donationModule.appendChild(notification);
    setTimeout(() => {
      notification.style.display = 'none';
      setTimeout(() => notification.parentNode && notification.parentNode.removeChild(notification), 300);
    }, 4000);
  }
  
  const preselectedOption = dropdownOptions.querySelector('.dropdown-option.selected') 
    || dropdownOptions.querySelector('.dropdown-option');

  if (preselectedOption) {
    selectedVariantId = preselectedOption.getAttribute('data-variant-id');
    selectedVariantTitle = preselectedOption.getAttribute('data-variant-title');
    selectedPrice = parseInt(preselectedOption.getAttribute('data-variant-price'));
    updateSelectedDisplay();
    enableAddButton();
  }


  dropdownOptions.addEventListener('keydown', e => {
    const options = Array.from(dropdownOptions.querySelectorAll('.dropdown-option'));
    const currentIndex = options.findIndex(opt => opt === document.activeElement);
    switch (e.key) {
      case 'ArrowDown': e.preventDefault(); options[(currentIndex + 1) % options.length].focus(); break;
      case 'ArrowUp': e.preventDefault(); options[(currentIndex - 1 + options.length) % options.length].focus(); break;
      case 'Enter': case ' ': e.preventDefault(); if (document.activeElement.classList.contains('dropdown-option')) document.activeElement.click(); break;
      case 'Escape': closeDropdown(); dropdownSelected.focus(); break;
    }
  });

  dropdownOptions.querySelectorAll('.dropdown-option').forEach(option => {
    option.setAttribute('tabindex', '0');
    option.setAttribute('role', 'option');
  });

  dropdownSelected.setAttribute('role', 'button');
  dropdownSelected.setAttribute('aria-haspopup', 'listbox');
  dropdownSelected.setAttribute('aria-expanded', 'false');
  dropdownOptions.setAttribute('role', 'listbox');

  const originalOpenDropdown = openDropdown;
  const originalCloseDropdown = closeDropdown;
  openDropdown = function() {
    originalOpenDropdown();
    dropdownSelected.setAttribute('aria-expanded', 'true');
  };
  closeDropdown = function() {
    originalCloseDropdown();
    dropdownSelected.setAttribute('aria-expanded', 'false');
  };
}

function observeCartChanges() {
  const cartSelectors = ['[id^="MainCart-"]', '[id^="CartDrawer-"]'];
  
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        const donationModules = document.querySelectorAll('[data-donation-module]:not([data-initialized="true"])');
        if (donationModules.length > 0) {
          console.log('Cart updated, reinitializing donation modules...');
          setTimeout(initDonationModule, 100);
        }
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  cartSelectors.forEach(selector => {
    const cartElements = document.querySelectorAll(selector);
    cartElements.forEach(cartElement => {
      observer.observe(cartElement, { childList: true, subtree: true });
    });
  });

  const bodyObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          cartSelectors.forEach(selector => {
            if (node.matches && node.matches(selector)) {
              observer.observe(node, { childList: true, subtree: true });
              console.log('New cart element detected, adding observer');
            }
          });
        }
      });
    });
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });
}

function safeInitDonation() {
  initDonationModule();
  if (!document.querySelector('[data-donation-module]')) {
    setTimeout(initDonationModule, 500);
    setTimeout(initDonationModule, 1000);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  safeInitDonation();
  observeCartChanges();
});

if (customElements.whenDefined) {
  customElements.whenDefined('cart-drawer').then(() => setTimeout(safeInitDonation, 100));
  customElements.whenDefined('main-cart').then(() => setTimeout(safeInitDonation, 100));
}

document.addEventListener('cart:updated', safeInitDonation);
document.addEventListener('cart:refresh', safeInitDonation);
window.addEventListener('load', () => setTimeout(safeInitDonation, 200));
